module.exports = __webpack_public_path__ + "static/media/finish_white.216ff429.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/finish_white.svg
// module id = 322
// module chunks = 0